module.exports = __webpack_public_path__ + "static/media/profile_img.0ead5965.png";